import react from "react";
import SpecialOffersSection from "../Special-offer.js";
function Offer() {
  return (
    <>
      <SpecialOffersSection />
    </>
  );
}
export default Offer;
